import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import '../outterpages.css'
// import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.png';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import commoditiesban from '../../../assets/Images/Outterpage/commodities-banner.webp'
import commoditiescta from '../../../assets/Images/Outterpage/cta-commodites.webp'
import pambanner from '../../../assets/Images/Outterpage/pam-banner.webp'
import mt5tradebanner from '../../../assets/Images/Outterpage/mt5-trader.webp'
import imgcrn from '../../../assets/Images/Outterpage/img-crn.webp'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
    '&:nth-of-type(odd)': {
        background: "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
    },
    // Hide the last border of the table
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
    {
        name: "Sherly",
        position: "CEO",
        text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
    },
    {
        name: "Carlos",
        position: "Product Manager",
        text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
    },
    // {
    //   name: "Rishi",
    //   position: "CEO",
    //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
    // },
];

const options = {
    margin: 50,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: false, // Hide default dots
    loop: true,
    smartSpeed: 800,
    nav: true, // We will use custom navigation
    responsive: {
        0: {
            dots: true,
            nav: false,
        },
        768: {
            dots: false,
            nav: true,
        },
    },
};

const marketData = [
    { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];


const tableData = [
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },

]
const accordianData = [
    {
        question: "Is there a minimum investment required for a Finowiz PAMM account?",
        answer: "Yes, Finowiz PAMM accounts have minimum investment requirements. For money managers, the minimum fee to open an account is USD 500, while for investors, the minimum initial deposit is USD 50. These amounts are necessary to start and access the PAMM portal.",

        panel: "panel1"
    },
    {
        question: "Can investors choose their preferred money managers in Finowiz PAMM?",
        answer: "Yes, copy trading can be advantageous for beginners by enabling them to learn from expert strategies and potentially earn while gaining market insights. However, it's important to understand the associated risks.",

        panel: "panel2"
    },
    {
        question: "Are there any fees associated with Finowiz PAMM accounts?",
        answer: "Yes, Finowiz PAMM accounts may involve fees. Money managers can establish flexible fee structures, often referred to as `offers ,` which outline the charges for their services. Investors should review these fee structures when selecting a money manager to understand any associated costs.",

        panel: "panel3"
    },

]
const cardset = [
  {
    head: "Expanded Market Access",
    para: "Finowiz empowers traders and investors with seamless access to a wide range of global financial markets. Whether it's equities, commodities, forex, or derivatives, our platform ensures you can trade across borders with confidence. Tap into new opportunities and diversify your portfolio like never before.",
  },
  {
    head: "Enhanced Hedging Capabilities",
    para: "Mitigate risk and protect your capital with advanced hedging tools built into the Finowiz ecosystem. Whether you’re managing volatility or securing profits, our platform offers the flexibility to execute complex strategies with precision and control, ensuring your exposure is always aligned with your risk appetite.",
  },
  {
    head: "Flexible Timeframe Choices",
    para: "Adapt your trading strategy to any market condition with Finowiz’s flexible timeframe options. From scalping on the minute charts to long-term investment analysis, our platform allows you to customize your view, making it easier to identify trends, entry points, and optimal exits — all in real time.",
  },
  {
    head: "Sophisticated Programming Language",
    para: "Harness the power of automation and customization with Finowiz’s integrated scripting language. Designed for both beginners and advanced users, our platform lets you create, test, and deploy custom indicators and strategies to streamline your trading process and gain a competitive edge.",
  },
  {
    head: "Enhanced Market Depth",
    para: "Gain a clearer view of liquidity and pricing with real-time market depth data. Finowiz equips you with Level II insights and order book transparency, enabling you to make smarter trading decisions by seeing the true supply and demand dynamics behind every price move.",
  },
  {
    head: "Built-In Economic Calendar",
    para: "Stay ahead of key financial events with our built-in economic calendar. Finowiz keeps you informed of global releases, central bank decisions, and market-moving data, all synced within the platform — so you can prepare, react, and strategize with perfect timing.",
  },
];

const MT5Trader = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const md900 = useMediaQuery(theme.breakpoints.up("900"));
    const xs375 = useMediaQuery(theme.breakpoints.up("380.99"));
    const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const md1200 = useMediaQuery(theme.breakpoints.down("1200"));
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <div className="OutterPage">
            <Header />
            <div className="bg-outer comm-ot-bg">
                <section className="banner outter-banner">
                    <div className="contain-width">
                        <Grid container sx={{ alignItems: "flexStart" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: "center" }}>
                                <div
                                    className="banner-left "
                                    style={{ height: xl ? "500px" : "auto", placeContent: "center" }}
                                >
                                    <p>MT5 PLATFORMS</p>
                                    <h1 className="mb-30 mt-10">
                                        Trade on Premier <span>MT5 Platforms</span>
                                    </h1>
                                    <p>Enhance your trading strategy with Finowiz's Copy Trading feature. Easily replicate successful trades and adopt effective strategies from experienced traders to optimize your trading performance.e commodities such as metals and energies to explore new market opportunities, protect against inflation, and diversify your investment portfolio effortlessly with Finowiz.</p>
                                    {/* <div
                  className="display-1 btn flex-wrap "
                  style={{ marginBottom: matches ? "40px" : "20px" }}
                >
                  <Link to="/open-new-account" className="bg-btn">
                    Get Started
                  </Link>
                </div> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                <div className="text-center ">
                                    <img width="90%" src={mt5tradebanner} />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </section>

                <section className="trade-easy sec-3">
                    <div className="contain-width">
                        <div className="heading">
                            <p>
                                <span>BENEFITS</span>
                            </p>
                            <h2>
                                Why Choose <span>Finowiz</span> for Forex Trading?
                            </h2>
                            {/* <p>
                                Figma ipsum component variant main layer. Prototype share asset stroke distribute star create. Rectangle stroke auto figjam project library select.
                            </p> */}
                        </div>
                        <Grid container spacing={5} className="card-set-hv">
                            {
                                cardset.map((item) => (
                                    <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                        <div>
                                            <img src={cardimg} />
                                        </div>
                                        <p className="mt-10 head"><span className="grd">{item.head}</span></p>
                                        <p className="mt-10">{item.para}</p>

                                    </Grid>
                                ))
                            }

                        </Grid>


                    </div>
                </section>

            </div >
            <section className="trade-easy sec-3  roadmap-bg2  ">
                <div className="contain-width">
                    <div className="heading">
                        <p>
                            <span>INSTALL</span>
                        </p>
                        <h2>
                            How to Install MT5 Platform?
                        </h2>

                    </div>
                    <Grid container spacing={5} className="card-set-mt">
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="mt-box ">
                            <span className="crn-alg">
                                {
                                  xs375&&  <span className="crn-box">
                                        <img width="90%" src={imgcrn} />
                                    </span>
                                }
                                <div className="txt-content" style={{ padding: "30px 100px", textAlign: "center" }}>
                                    <p>Step 2</p>
                                    <p><span className="grd">Run the .exe file</span></p>
                                </div>
                            </span>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} className={md1200?"mt-box":"mt-box mt-50 "}>
                            <span className="crn-alg">
                            {
                                  xs375&&  <span className="crn-box">
                                        <img width="90%" src={imgcrn} />
                                    </span>
                                }
                                <div className="txt-content" style={{ padding: "30px 100px", textAlign: "center" }}>
                                    <p>Step 1</p>
                                    <p><span className="grd">Download the platform</span></p>
                                </div>
                            </span>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} className={md1200?"mt-box":"mt-box mt-50 "}>
                            <span className="crn-alg">
                            {
                                  xs375&&  <span className="crn-box">
                                        <img width="90%" src={imgcrn} />
                                    </span>
                                }
                                <div className="txt-content" style={{ padding: "30px 100px", textAlign: "center" }}>
                                    <p>Step 3</p>
                                    <p><span className="grd">Login to your Finowiz account</span></p>
                                </div>
                            </span>
                        </Grid>
                    </Grid>


                </div>
            </section>

            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            {/* <p>
                            Learn to trade without using real money, refining your
                            strategies and learning from mistakes.
                          </p> */}
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>



            <Footer />
        </div >
    );
};

export default MT5Trader;
